import { FC } from 'react';
import cn from 'classnames';
import styles from './procedure.module.scss';

interface ProcedureDescriptionProps {
    description: string;
    className?: string;
}

const ProcedureDescription: FC<ProcedureDescriptionProps> = ({
    description,
    className,
}) => {
    return (
        <div className={cn(styles.note, className)} role="note">
            <span className={styles.icon} aria-hidden>
                ☝️
            </span>
            <p className={styles.content}>{description}</p>
        </div>
    );
};

export default ProcedureDescription;
